export default function Hero() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/60 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-100/50 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-5 whitespace-nowrap">
              日更不断 · 海量免费
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              歪歪漫画网
              <span className="block text-2xl md:text-3xl lg:text-4xl text-foreground-700 font-medium mt-1">
                你的在线漫画追更天堂
              </span>
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-medium mb-5 font-heading">
              韩漫日漫国漫，下拉式畅快阅读，随时随地免费看全集
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              歪歪漫画网专注为漫画爱好者提供优质的在线阅读体验。平台汇集海量韩漫、日漫、国漫资源，覆盖热血、恋爱、奇幻、悬疑等全类型题材，每日稳定更新超过200部热门漫画。无论你是追更党还是补番党，都能在这里找到属于自己的漫画天地——支持下拉式流畅阅读模式，无需翻页等待，沉浸感十足。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">200+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">日更新部数</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">50000+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">收录漫画</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">全类型</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">题材覆盖</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => { e.preventDefault(); scrollTo('#cards'); }}
                className="px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer w-full sm:w-auto text-center"
              >
                开始阅读
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); scrollTo('#ranking'); }}
                className="px-8 py-3 border-2 border-primary-300 text-primary-600 font-semibold rounded-full hover:bg-primary-50 transition-colors text-sm whitespace-nowrap cursor-pointer w-full sm:w-auto text-center"
              >
                热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=An%20artistic%20illustration%20of%20colorful%20comic%20panels%20floating%20in%20a%20warm%20atmosphere%2C%20manga%20reading%20scene%20with%20soft%20coral%20and%20cream%20color%20palette%2C%20clean%20minimalist%20aesthetic%2C%20editorial%20quality%20composition%2C%20subtle%20Japanese%20manga%20influence%20with%20modern%20web%20design%20elements%2C%20warm%20ambient%20lighting%2C%20cozy%20reading%20vibe%2C%20no%20text%20on%20the%20panels&width=800&height=600&seq=hero-manga-2026&orientation=landscape"
                alt="歪歪漫画网 - 在线漫画阅读体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}